module.exports = __webpack_public_path__ + "static/img/收到資料啦_300×300.46e64f01.png";